import { Navigate } from 'react-router-dom';
import { useAuth, homePathForRole } from '../auth';

/**
 * `/` — role-based redirect. Unauthenticated → /login; AGENT → /agent/dashboard;
 * admin-area roles → /admin.
 */
export default function RootRedirect() {
  const { isAuthenticated, role, initializing } = useAuth();
  if (initializing) {
    return (
      <div className="cl full col center" style={{ height: '100vh', justifyContent: 'center' }}>
        <div className="meta">Loading…</div>
      </div>
    );
  }
  if (!isAuthenticated || !role) return <Navigate to="/login" replace />;
  return <Navigate to={homePathForRole(role)} replace />;
}
